import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';

import { CmxWebComponentsModule } from '@cmx-web-components/angular';
import { CmxApiConfig, CmxApiModule } from '@cemex-core/cmx-api';
import { CmxHttpClient } from './services/api.service';

import { CmxClientLayoutComponent } from './container/cmx-client-layout.component';

import { LegalEntitiesService } from './services/legal-entities.service';
import { MenuService } from './services/menu.service';
import { ICmxClientConfig } from './typings/client-config';
import { CmxClientComponentsModule } from './components/cmx-client-components.module';
import { CmxTranslateLoader } from './helpers/translate-loader';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from './services/config.service';
import { StoreModule } from '@ngrx/store';
import { appReducer } from './store/reducers';
import { RouterModule } from '@angular/router';
import { AuthService } from './services/auth.service';
import { AlertService } from './services/alerts.service';
import { CmxClientService } from './services/cmx-client.service';
import { PersistenceService } from './services/persistence.service';
import { AuthGuard } from './guards/auth.guard';
import { LoginGuard } from './guards/login.guard';
import { WizelineChatbotComponent } from '@cemex/cmx-wizeline-chatbot-v7';
import { CmxChatbotModule } from '@cemex/cmx-chatbot-v15';
import { Broadcaster } from '@cemex-core/angular-services-v8';
import { WindowRef } from './services/windowRef.service';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { NO_ERRORS_SCHEMA } from '@angular/core';
import { ParametersService } from './services/parameters.service';
import { CopyrightService } from './services/copyright.service';
import { LanguageService } from './services/language.service';
import { HttpCemex, ProjectSettings, SessionService } from '@cemex-core/angular-services-v8';
import { CmxLayoutModule } from './cmx-layout/cmx-layout.module';
import { CmxLayoutService } from './cmx-layout/services/cmx-layout.service';

const cmxApiConfig: CmxApiConfig = {
  httpClient: CmxHttpClient,
};

@NgModule({
  declarations: [CmxClientLayoutComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CmxLayoutModule,
    CmxClientComponentsModule,
    WizelineChatbotComponent,
    CmxChatbotModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: CmxTranslateLoader,
        deps: [HttpClient, ConfigService],
      },
    }),
    StoreModule.forRoot(
      {
        app: appReducer,
      },
      { runtimeChecks: { strictStateImmutability: false, strictActionImmutability: false } },
    ),
    CmxApiModule.forRoot(cmxApiConfig),
    CmxWebComponentsModule,
    CmxClientComponentsModule,
    RouterModule,
  ],
  exports: [CmxClientLayoutComponent, CmxClientComponentsModule, CmxApiModule, TranslateModule],
  providers: [CmxLayoutService, Broadcaster, WindowRef],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class CmxClientLayoutModule {
  static forRoot(config: ICmxClientConfig): ModuleWithProviders<CmxClientLayoutModule> {
    return {
      ngModule: CmxClientLayoutModule,
      providers: [
        AlertService,
        AuthService,
        AuthGuard,
        LoginGuard,
        ConfigService,
        CmxClientService,
        MenuService,
        LegalEntitiesService,
        PersistenceService,
        CmxHttpClient,
        Broadcaster,
        ParametersService,
        CopyrightService,
        LanguageService,
        SessionService,
        HttpCemex,
        ProjectSettings,
        {
          provide: 'ClientConfig',
          useValue: config,
        },
      ],
    };
  }
}
